import React, { Component } from 'react';
import { Container, Responsive } from 'semantic-ui-react';

import IMGFX_BACKGROUND from '../assets/img/theme-fx.png';

export default class GradientContainer extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <Container fluid className="mpost-gradient-section" textAlign={this.props.textAlign}>
                <div className="mpost-gradient-section--gfx" style={{ backgroundImage: `url(${IMGFX_BACKGROUND})` }}>
                    <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                        <Container fluid={this.props.fluid} className="mpost-section" textAlign={this.props.textAlign}>
                            {this.props.children}
                        </Container>
                    </Responsive>
                    <Responsive {...Responsive.onlyMobile}>
                        <Container fluid={this.props.fluid} className="mpost-section mobile" textAlign={this.props.textAlign}>
                            {this.props.children}
                        </Container>
                    </Responsive>
                </div>
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/GradientContainer.js